import { Component, OnInit } from '@angular/core';
import { IAccount, IVisibleUsers } from '../../../store/models/account.model';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { StaticDataSource } from '../../../datasources/static.datasource';
import { DataSourceParams, ETableColumnType, ITableColumn } from '../../../store/models/table.model';
import { ViewRepresentativesStatusComponent } from '../../view-representatives/view-representatives-status/view-representatives-status.component';
import { IUserSessionData, UserType } from '../../../store/models/user.model';

export const SUBSCRIPTION_PAID_BY_MANAGER = 'manager';
export const SUBSCRIPTION_PAID_BY_USER = 'user';

@Component({
  selector: 'app-manager-select-dialog',
  templateUrl: './manager-select-dialog.component.html',
  styleUrls: ['./manager-select-dialog.component.scss'],
})
export class ManagerSelectDialogComponent implements OnInit {

  user: IAccount;

  currentUser: IUserSessionData;

  managers: IAccount[] = [];

  inputForm: FormGroup;

  dataSource: StaticDataSource<IVisibleUsers>;

  emptyDataText: string = 'No subordinate users, assigned to this';

  tableColumns: ITableColumn<IVisibleUsers>[] = [
    {
      id: 'first_name',
      title: 'First Name',
    },
    {
      id: 'last_name',
      title: 'Last Name',
    },
    {
      id: 'id',
      title: 'Account ID',
    },
    {
      id: 'email',
      title: 'Email',
    },
    {
      id: 'status',
      title: 'Status',
      hint: 'status_accounts',
      type: ETableColumnType.COMPONENT,
      componentProperties: {
        component: ViewRepresentativesStatusComponent,
        mapData: {
          account: {
            instance: 'column',
          },
        },
      },
    },
    {
      id: 'role',
      title: 'Role',
      renderer: row => {
        return row.account_role.charAt(0).toUpperCase() + row.account_role.slice(1);
      },
    },
  ];

  dataSourceParams: DataSourceParams = {
    page: 1,
    pageSize: 10,
    sortAttr: 'account_id',
    sortDir: 'desc',
    filters: {},
  };

  tableReady: boolean;

  constructor() {
  }

  get manager_id(): number | string {
    return this.inputForm.get('manager_id').value;
  }

  ngOnInit(): void {
    if (this.inputForm) {
      this.inputForm.addControl('manager_id', new FormControl(this.user.manager_id || ''));
      this.inputForm.addControl('paid_by', new FormControl('manager', [Validators.required]));
    }

    if ([UserType.MANAGER, UserType.PARTNER].indexOf(this.user.account_role) !== -1) {
      this.dataSource = new StaticDataSource(this.user.visible_users);
      this.emptyDataText += ` ${this.user.account_role}`;
      this.tableReady = true;
    }
  }

  getManagers() {
    const managers = this.managers.map(manager => {
      return {
        label: manager.email,
        value: manager.account_id,
      };
    });

    return [{ label: 'Please, select...', value: '' }, ...managers];
  }

  resetManager() {
    this.inputForm.get('manager_id').setValue('');
  }

}
